/**
 * postMessage contract between the OAuth2 popup (this app) and the parent window that opened it.
 * The parent should validate `event.origin` and `event.data.type` before using the token.
 */
import type { OAuth2CallbackParseResult } from './parseOAuth2CallbackUrl';

export const OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE = 'comet-review.oauth2.popup-callback' as const;

export interface IOAuth2PopupCallbackAuthCodePayload {
    code: string;
    state?: string;
}

export interface IOAuth2PopupCallbackAccessTokenPayload {
    accessToken: string;
    tokenType?: string;
    expiresIn?: number;
    state?: string;
}

export interface IOAuth2PopupCallbackErrorPayload {
    error: string;
    errorDescription?: string;
    state?: string;
}

export type OAuth2PopupCallbackMessageData =
    | { type: typeof OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE; status: 'authcode'; payload: IOAuth2PopupCallbackAuthCodePayload }
    // | { type: typeof OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE; status: 'accesstoken'; payload: IOAuth2PopupCallbackAccessTokenPayload }
    | { type: typeof OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE; status: 'error'; payload: IOAuth2PopupCallbackErrorPayload };

export const postOAuth2ResultToOpener = (opener: Window, result: OAuth2CallbackParseResult, targetOrigin: string): void => {
    if (result.kind === 'authcode') {
        const data: OAuth2PopupCallbackMessageData = {
            type: OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE,
            status: 'authcode',
            payload: {
                code: result.code,
                state: result.state,
            },
        };
        opener.postMessage(data, targetOrigin);
        return;
    }

    // if (result.kind === 'accesstoken') {
    //     const data: OAuth2PopupCallbackMessageData = {
    //         type: OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE,
    //         status: 'accesstoken',
    //         payload: {
    //             accessToken: result.accessToken,
    //             tokenType: result.tokenType,
    //             expiresIn: result.expiresIn,
    //             state: result.state,
    //         },
    //     };
    //     opener.postMessage(data, targetOrigin);
    //     return;
    // }

    if (result.kind === 'error') {
        const data: OAuth2PopupCallbackMessageData = {
            type: OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE,
            status: 'error',
            payload: {
                error: result.error,
                errorDescription: result.errorDescription,
                state: result.state,
            },
        };
        opener.postMessage(data, targetOrigin);
        return;
    }

    const data: OAuth2PopupCallbackMessageData = {
        type: OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE,
        status: 'error',
        payload: {
            error: 'invalid_callback',
            errorDescription: 'No authorization code, access token, or OAuth error was present in the callback URL.',
        },
    };
    opener.postMessage(data, targetOrigin);
};
